import React, { Component } from "react";
// import DropdownSelect from "../main/DropdownSelect";
// import { default as ReactSelect } from "react-select";
// import $ from 'jquery'; 



export var checkbox_selected = { 
    has_signature: false,
    curation_complete: false,
}

export default class FilterCheckbox extends Component {

    constructor(props) {
        
        super(props);

        this.title = props.title;
        this.id = props.id;
        this.text = props.text;
        this.isSelected = props.isSelected;

        this.onCheckboxChange = props.onCheckboxChange;

        this.state = {
            isSelected: this.isSelected,
        };

        this.checkbox_selected = checkbox_selected;
        this.checkbox_selected[this.id] = this.isSelected;

    }
    
    handleChange = (e) => {
        const echecked = e.target.checked;

        this.setState({
            isSelected: echecked,
        });

        this.checkbox_selected[this.id] = echecked;
        this.onCheckboxChange(this.checkbox_selected);
    
    };
    
    render(){
        return (

            <div className={`${this.state.isSelected ? "FilterCheckbox filter-card-checkbox filter-active" : "FilterCheckbox filter-card-checkbox"}`}>
                
                <label htmlFor={this.id}>
                    
                    <input id={this.id} name={this.title} value={this.title} type="checkbox" onChange={this.handleChange} checked={this.state.isSelected} />
                    <span class="checkmark"></span>
                    <text>{this.text}</text>
                    
                </label>
            </div>

        )

    }
}